

















































































































































































































import Vue from 'vue'
import SingleCast from '@/components/SingleCast'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import ClipMaker from '@/components/Clipper/ClipMaker'
import ClipOverview from '@/components/Clipper/ClipOverview'
import CreateEditCastTemplate from '@/components/CreateEditCastTemplate'
import Modal from '@/components/Modal'
import { Button, Popover, Table, TableColumn } from 'element-ui'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { sortBy } from 'lodash'
import fb from '../../firebase'
import moment from 'moment'
import {
  CallTriage,
  Cast,
  CastTableItem,
  CustomRtmpDestination,
  CustomRtmpDestinationType,
  InvitedCaster
} from '@/types/casts'
import { CloudCastEvent } from '@/types/events'
import { UserProfile } from '@/types/users'
import { Stream, StreamsManager, StreamType } from '@/types/streams'
import { CollectionNames, KeyDict } from '@/types'
import { TeamMember, MemberRole } from '@/types/teams'
import { UnsubscribeFunction, WATERMARK_DEFAULT, ArchiverTask } from '../../store/types'
import CasterArchive from '@/components/CasterArchive/CasterArchive.vue'
import CastSupportBadge from '@/components/CastSupportBadge/CastSupportBadge.vue'
import CastEnvBadge from '@/components/CastEnvBadge/CastEnvBadge.vue'
import '@/styles/components/buttons.scss'
import '@/styles/components/forms.scss'
import './EventListItem.scss'
import clock from '@/classes/Clock'
import subscribeArchiverQueue from '@/mixins/SubscribeArchiverQueue'
import helpers from '@/helpers'
import { Feature, hasFeature } from '@/featureFlags/featureFlags'

export default Vue.extend({
  name: 'EventListItem',
  mixins: [subscribeArchiverQueue],
  props: {
    event: {
      type: Object as () => CloudCastEvent,
      required: true
    },
    team: {
      type: Array as () => UserProfile[] | undefined
    },
    activeTeam: {
      type: String
    },
    currentUserId: {
      type: String
    },
    eventStatus: {
      type: String
    },
    castAudioActive: {
      type: String
    },
    teamStreams: {
      type: Object as () => KeyDict<Stream> | undefined
    },
    streamsManager: {
      type: Object as () => StreamsManager | undefined
    },
    audioActivated: {
      type: Boolean
    },
    userProfile: {
      type: Object as () => UserProfile | undefined
    },
    forceUpdateList: {
      type: Number,
      default: 0
    },
    showIntro: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasCopiedCasts (): boolean {
      return this.casts && Object.values(this.casts).some(cast => !!cast.originalCast)
    },
    canReadArchive (): boolean {
      return this.$can(AbilityAction.Read, AbilitySubject.Archive)
    },
    canCreateTemplates (): boolean {
      return this.$can(AbilityAction.Create, AbilitySubject.CastTemplates)
    },
    canDoOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    eventIsActive (): boolean {
      const seconds = Date.now() / 1000
      return seconds > this.event.start_date.seconds && seconds < this.event.end_date.seconds
    },
    editEventButtonName (): string {
      if (this.event?.name === undefined) return 'button-edit-event'
      return `button-edit-event-${this.event.name.replace(' ', '-')}`
    },
    canSeeEvent (): boolean {
      // FIXME: This doesn't play well with custom team roles. Should probably have its own AbilityAction?
      //        Or it might even be removed once there's a 1-to-1 mapping between a cast and an event.
      if (this.teamMembers[this.currentUserId]?.role === MemberRole.Admin) return true
      if (Object.keys(this.casts).length > 0) return true // There is at least one cast (that wasn't group-filtered out)
      return false
    },
    sortedCasts (): Cast[] {
      const casts: Cast[] = []
      const seconds = Date.now() / 1000
      Object.values(this.casts).forEach((cast) => {
        if (seconds <= cast.end_date.seconds && !this.castWasStopped(cast)) {
          casts.push(cast)
        }
      })
      // return sortBy(casts, 'name').reverse()
      return sortBy(casts, [o => o.name.toLowerCase()])
    },
    casttable () : CastTableItem[] {
      const casts: CastTableItem[] = []
      const seconds = Date.now() / 1000
      Object.values(this.casts).forEach((cast: Cast) => {
        if (seconds > cast.end_date.seconds || this.castWasStopped(cast)) {
          casts.push({
            id: cast.id || '',
            name: cast.name,
            lowercaseName: cast.name.toLowerCase(),
            startDate: this.formatDate(cast.start_date.seconds),
            endDate: this.formatDate(cast.end_date.seconds),
            outputs: this.outputsToString(cast.custom_rtmp_destinations || {}),
            casters: this.getCasters(cast.invited_casters),
            k360event: cast.k360_event_id || 0,
            feedNames: cast.feedname || {},
            hasArchive: !!cast.mp4 && cast.mp4.startsWith('http'),
            archivingText: this.archivingProgressText(cast.id),
            archiveExpired: this.archiveExpired(cast),
            watermark: !!cast.watermark,
            supportLevel: cast.supportLevel,
            castInfo: {
              start_date: cast.start_date,
              end_date: cast.end_date,
              status: cast.status
            } as Partial<Cast>
          })
        }
      })
      return casts
    },
    archiverQueue (): KeyDict<ArchiverTask> {
      return this.$store.direct.state.opsmonitor.archiverQueue
    },
    teamMembers (): KeyDict<TeamMember> {
      return this.$store.direct.state.team.team.members ?? {}
    }
  },
  watch: {
    forceUpdateList (): void {
      this.loadCasts()
    }
  },
  data: () => ({
    casts: {} as KeyDict<Cast>,
    castsLoaded: false,
    showCasts: false,
    openclipper: null as null|string,
    videoduration: 0,
    showCreateCastTemplateModal: false,
    selectedCast: {} as Cast,
    globalMsg: '',
    unsubscribefunctions: {} as KeyDict<UnsubscribeFunction>,
    unsubscribeEvent: null as UnsubscribeFunction|null
  }),
  created () {
    this.loadCasts()
  },
  destroyed () {
    this.unloadEvent()
  },
  methods: {
    archivingProgressText (castId: string): string {
      const castArchiveTask = this.archiverQueue[castId]
      if (castArchiveTask === undefined) return ''
      for (const [itemId, queueItem] of Object.entries(castArchiveTask)) {
        if (itemId.startsWith('full')) {
          return `Archiving ${helpers.getProgressText(queueItem.progress_pct)}`
        }
      }
      return ''
    },
    archiveExpired (cast: Partial<Cast>): boolean {
      const maxRegularDays = hasFeature(Feature.SELF_SERVE) ? 14 : 90 // 2 weeks or 3 months
      const maxTimeWatermarkArchive = 7  * 24 * 3600 // a week
      const maxTimeRegularArchive = maxRegularDays * 24 * 3600
      const maxTime = cast.watermark ? maxTimeWatermarkArchive : maxTimeRegularArchive
      return (clock.nowInSeconds() - cast.end_date.seconds) > maxTime
    },
    openOpsPage (castId: string): void {
      const url = helpers.getURL(this.$router, 'opsdetails', { id: castId })
      window.open(url, '_blank')
    },
    casterFeedNames (casterId, feedMap): string[] {
      // find stream feednames (eg used by Librato Charts)
      // note: a single caster can have multiple streams (eg after reconnecting)
      const matches: string[] = []
      Object.keys(feedMap || {}).forEach(key => {
        if (feedMap[key] === casterId) {
          matches.push(key)
        }
      })
      return matches
    },
    toggleShowCasts (): void {
      if(this.eventStatus === 'completed' && Object.values(this.casts).length === 0) {
        this.showCasts = false
      } else {
        this.showCasts = !this.showCasts
      }
    },
    unloadEvent (): void {
      if (this.unsubscribeEvent !== null) {
        this.unsubscribeEvent()
        this.unsubscribeEvent = null
      }
      Object.values(this.unsubscribefunctions).forEach((func: Function) => func())
      this.unsubscribefunctions = {}
    },
    loadCasts (): void {
      this.casts = {}
      const eventId = this.event.id
      this.unloadEvent()
      if (this.activeTeam === '') {
        return
      }
      // FIXME: an event should have a valid id => CloudCastEvent constructor
      if (eventId === undefined) {
        return
      }
      const isCasterInCast = (cast: Cast) => {
        const caster = cast.invited_casters[this.currentUserId]
        return caster !== undefined && caster.deleted !== true && caster.triage !== CallTriage.Rejected
      }
      const query = fb.db.collection(CollectionNames.CASTS)
        .where('team_id', '==', this.activeTeam)
        .where('event_id', '==', eventId)
      this.unsubscribeEvent = query.onSnapshot(casts => {
        for (let i = 0; i < casts.docs.length; i++) {
          const tmpCast = casts.docs[i].data()
          tmpCast.id = casts.docs[i].id

          //When user is not an Admin, filter out all casts user is not in a member group for, if user has assigned groups
          if (
            this.teamMembers[this.currentUserId]?.role !== MemberRole.Admin
            //Only if cast was filtered
            && tmpCast.teamGroups !== undefined
            && tmpCast.teamGroups.length !== 0
          ) {
            //Only if user has assigned groups
            //and only if not filtered to one of user's assigned groups
            const userGroups = this.userProfile?.teamGroups?.[this.activeTeam] ?? []
            if (userGroups.length && !tmpCast.teamGroups.some(groupId => {
              return userGroups.includes(groupId)
            })) continue //Don't show cast
          }
          let currentUserWasCaster = false
          const canRead = this.$can(AbilityAction.Read, AbilitySubject.Cast)
          const castExisted = this.casts.hasOwnProperty(tmpCast.id)
          if (castExisted) {
            currentUserWasCaster = isCasterInCast(this.casts[tmpCast.id])
          }

          // FIXME: Make sure `tmpCast` is a valid Cast object so we don't have to do this check and use `as Cast`.
          if (tmpCast.invited_casters === undefined) tmpCast.invited_casters = {}
          const currentUserIsCaster = isCasterInCast(tmpCast as Cast)
          if (currentUserWasCaster && !currentUserIsCaster && !canRead) {
            // caster was removed from cast
            Vue.delete(this.casts, tmpCast.id)
          }

          if (currentUserIsCaster || canRead) {
            // set the initial data we have from the query
            if (!tmpCast.deleted)
              Vue.set(this.casts, tmpCast.id, tmpCast)
            else if (tmpCast.id in this.casts)
              Vue.delete(this.casts, tmpCast.id)
            // subscribe to snap shots of these docs
            if (this.unsubscribefunctions[tmpCast.id] !== undefined) {
              this.unsubscribefunctions[tmpCast.id] = fb.db.collection(CollectionNames.CASTS).doc(tmpCast.id).onSnapshot(snap => {
                const tmpSnap = snap.data()
                if (tmpSnap && !tmpSnap.deleted) {
                  tmpSnap.id = tmpCast.id
                  Vue.set(this.casts, tmpCast.id, tmpSnap)
                } else if (tmpCast.id in this.casts) {
                  Vue.delete(this.casts, tmpCast.id)
                }
              }, error => {
                console.error('error loadCasts ' + tmpCast.id + ' ' + error)
              })
            }
          }
        }
        this.castsLoaded = true
      }, error => {
        console.error('error loadCasts ' + this.activeTeam + ' ' + error)
      })
    },
    outputsToString (outputs: KeyDict<CustomRtmpDestination>|undefined): string {
      if (outputs === undefined) {
        return ''
      }
      let outputstring = ''
      Object.values(outputs).forEach(output => {
        if (output.type === CustomRtmpDestinationType.URL) {
          outputstring += output.url + ', '
        } else if (this.teamStreams) {
          const stream = Object.values(this.teamStreams).find(stream => {
            return stream.type === StreamType.Output && stream.srcurl === output.url && !stream.deleted && stream.name
          })
          if (stream) {
            outputstring += stream.name + ', '
          }
        }
      })
      return outputstring.substr(0, outputstring.length - 2)
    },
    createClip (offsets: { from: number, to: number, name: string }): void {
      if (this.openclipper !== null) {
        const clipinfo = {
          cast: this.casts[this.openclipper].id,
          k360event: this.casts[this.openclipper].k360_event_id,
          start: offsets.from,
          end: offsets.to,
          name: offsets.name
        }
        this.$store.direct.dispatch.events.makeClip(clipinfo)
      }
    },
    deleteClip (clipId: string): void {
      if (this.openclipper !== null) {
        const data = {
          clipid: clipId,
          cast: this.openclipper
        }
        this.$store.direct.dispatch.events.deleteClip(data)
      }
    },
    clipInfoUpdated (videoduration: number): void {
      this.videoduration = videoduration
    },
    getCasters (casterKeys: KeyDict<InvitedCaster>): UserProfile[] {
      const casters: UserProfile[] = []
      if (!casterKeys || !this.team) return casters
      
      for (const casterId of Object.keys(casterKeys)) {
        const match = this.team.find((member) => member.user_id === casterId)
        if (match) casters.push(match)
      }

      return casters
    },
    getInputName (inputUrl: string): string {
      let name = ''
      if (this.teamStreams && this.teamStreams.hasOwnProperty(inputUrl)) {
        name = this.teamStreams[inputUrl].name
      }
      return name
    },
    editCast (cast: Cast): void {
      this.$emit('editCast', cast)
    },
    copyCast (cast: Cast): void {
      this.$emit('copyCast', cast)
    },
    copyOutputs (cast: Cast): void {
      this.$emit('copyOutputs', cast)
    },
    stopCast (cast: Cast): void {
      this.$emit('stopEvent', cast.event_id)
    },
    deleteCast (cast: Cast): void {
      this.$emit('deleteEvent', cast.event_id)
    },
    castLoaded (): void {
      this.$emit('castLoaded')
    },
    castSingularity (): string {
      let text = 'casts'
      if (Object.values(this.casts).length === 1) {
        text = 'cast'
      }
      return text
    },
    showCastTemplateModal (cast: Cast): void {
      this.selectedCast = this.casts[cast.id]
      this.showCreateCastTemplateModal = true
    },
    closeCastTemplateModal (): void {
      this.selectedCast = {} as Cast
      this.showCreateCastTemplateModal = false
    },
    async saveCastTemplate (name: string) {
      const tmpTemplate: Cast = { ...this.selectedCast }
      tmpTemplate.name = name
      tmpTemplate.watermark = WATERMARK_DEFAULT
      tmpTemplate.supportLevel = this.$store.direct.getters.team.defaultSupportLevel
      tmpTemplate.platinumApproved = false
      await this.$store.direct.dispatch.castTemplates.saveCastAsTemplate(tmpTemplate)
      this.$message({
        type: 'success',
        message: 'Event template has been saved'
      })
    },
    checkCastStatus (cast: Cast): string {
      const seconds = Date.now() / 1000
      let status = 'active'
      if (seconds > cast.start_date.seconds && seconds < cast.end_date.seconds) {
        status = 'active'
      } else if (seconds > cast.end_date.seconds) {
        status = 'completed'
      } else if (seconds < cast.start_date.seconds) {
        status = 'future'
      }
      return status
    },
    addOutputVideo (vid) {
      this.$emit('addOutputVideo', vid)
    },
    setAudioSource (paramCast) {
      this.$emit('setActiveAudio', paramCast)
    },
    formatDate (paramDate: number): string {
      return moment.unix(paramDate).format('M/D/YYYY h:mm a')
    },
    requestCasterRepublish (params) {
      this.$emit('requestCasterRepublish', params)
    },
    castWasStopped (cast: Cast): boolean {
      if (cast.start_date.seconds === cast.end_date.seconds) return true
      return false
    },
    hasVideoData (castid: string): boolean {
      const cast = this.casts[castid]
      return !!(cast?.video_start_time)
    }
  },
  components: {
    SingleCast,
    ClipOverview,
    ClipMaker,
    Modal,
    CreateEditCastTemplate,
    CasterArchive,
    CastSupportBadge,
    CastEnvBadge,
    'clip-loader': ClipLoader,
    'el-button': Button,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-popover': Popover
  }
})
